"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cfeSobreConverter = void 0;
const cfeSobreConverter = {
    toFirestore(sobre) {
        return sobre;
    },
    fromFirestore(snapshot) {
        const data = snapshot.data();
        const sobre = {
            version: data.version,
            id: data.id,
            nroSobre: data.nroSobre,
            idCFEs: data.idCFEs,
            estado: data.estado,
            rutReceptor: data.rutReceptor,
            fechaGeneracion: data.fechaGeneracion,
            respuesta: data.respuesta,
            paraDGI: data.paraDGI,
            xmlSobre: data.xmlSobre ?? "",
            xmlACKReceptor: data.xmlACKReceptor ?? [],
            existeRespuestaComprobantes: data.existeRespuestaComprobantes,
            existeRespuestaComprobantesXML: data.existeRespuestaComprobantesXML,
            motivoRechazo: data.motivoRechazo,
            paramConsultaToken: data.paramConsultaToken,
            idReceptor: data.idReceptor
        };
        return sobre;
    }
};
exports.cfeSobreConverter = cfeSobreConverter;
